import { createRoot } from 'react-dom/client'
import './styles.css'
import App from './App'
import '@mantine/core/styles.css';

createRoot(document.getElementById('root')).render(
    <App />
)